module.exports = __webpack_public_path__ + "img/AL.613bd388.svg";